import React from "react";
import { Row, Col, Container } from 'react-bootstrap';
import emailIcon from '../assets/icons/account_icons/email.png';
import githubIcon from '../assets/icons/account_icons/github.jpg';
import linkedinIcon from '../assets/icons/account_icons/linkedin.png';


const Footer = () => {
    return (
        <>
            <Container>
                <Row className="justify-content-md-center" style={{ color: "white" }}>
                    <Col>Copyright {new Date().getFullYear()}&copy; All Rights Reserved </Col>
                    <Col className="account-icons" style={{ textAlign:"right" }}>
                        <a href="mailto:khemnarmayuresh19@gmail.com" target="_blank">
                            <img src={emailIcon} />
                        </a>
                        <a href="https://github.com/KhemnarMayuresh" target="_blank">
                            <img src={githubIcon} className="github-icon"/>
                        </a>
                        <a href="https://www.linkedin.com/in/mayuresh-khemnar-35b9b4197" target="_blank">
                            <img src={linkedinIcon} className="linkedin-icon"/>
                        </a>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Footer